<template>
  <v-container>
    <!-- Date Picker -->
    <v-row justify="center">
      <v-date-picker
        ref="picker"
        :picker-date.sync="pickerDate"
        v-model="date"
        width="200"
        full-width
        class="center"
      ></v-date-picker>
    </v-row>
      {{sortProgress}}
    <!-- Dialog, edit sales -->

    <v-dialog v-model="editSales" max-width="500px">
      <v-form ref="form5" lazy-validation="">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Sales Order</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.worknum"
                    label="Customer"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.customer"
                    label="Customer"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.product"
                    label="Product"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem.vdoor"
                    label="Value(Door)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem.vframe"
                    label="Value(Frame)"
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem.progress"
                    label="Progress"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem.vother"
                    label="Value(Other)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <!-- NEW DATE STARTS -->
                  <v-menu
                      ref="menu16"
                      v-model="menu16"
                      :close-on-content-click="false"
                      :return-value.sync="editedItem.date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.date"
                          label="Select Date"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[v => !!v || 'This is required']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.date"
                        no-title
                        scrollable
                        type="month"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu16 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu16.save(editedItem.date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  <!-- NEW DATE ENDS -->


                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.deliverynote"
                    label="Deliverynote"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.notes"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" @click="updateSales">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!--Dialog, edit purchase -->

    <v-dialog v-model="editPurchase" max-width="500px">
      <v-form ref="form6" lazy-validation="">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Purchase Order</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.ordernum"
                    label="Order#"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.supplier"
                    label="Supplier"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem.value"
                    label="Value"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.worknum"
                    label="Work#"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-menu>
                    <v-text-field
                      v-model="editedItem.date"
                      slot="activator"
                      label="Delivery Date"
                      prepend-icon="date_range"
                      :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                    <v-date-picker
                      v-model="editedItem.date"
                      type="month"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.type"
                    label="type"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.notes"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" @click="updatePurchase">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Dialog, edit fixed -->

    <v-dialog v-model="editFixed" max-width="500px">
      <v-form ref="form4" lazy-validation="">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Fixed Costs</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem2.supplier"
                    label="Supplier"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model.number="editedItem2.value"
                    label="Value"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem2.ordernum"
                    label="Ordernum"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="editedItem2.worknum"
                    :items="type"
                    :rules="[v => !!v || 'Product type is required']"
                    prepend-icon="whatshot"
                    label="Frequency"
                    required
                    chips
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="editedItem2.worknum === 'Quarterly'">
                  <v-menu>
                    <v-text-field
                      v-model="editedItem2.date"
                      :value="date"
                      slot="activator"
                      label="Delivery Date"
                      prepend-icon="date_range"
                      :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                    <v-date-picker
                      v-model="editedItem2.date"
                      type="month"
                      multiple
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="editedItem2.worknum === 'Yearly'">
                  <v-menu>
                    <v-text-field
                      v-model="editedItem2.date"
                      :value="date"
                      slot="activator"
                      label="Delivery Date"
                      prepend-icon="date_range"
                      :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                    <v-date-picker
                      v-model="editedItem2.date"
                      type="month"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem2.deliverynote"
                    label="Deliverynote"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem2.notes"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" @click="updateFixed">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Totals -->
    <v-layout row class="py-5">
      <!-- Left Column -->
      <v-layout column>
        <v-flex xs4>
          <h2 class="primary--text">
            Value(Doors):
            <span class="orange--text">£{{ this.doors.toLocaleString() }}</span>
          </h2>
        </v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Value(Frames):
            <span class="orange--text"
              >£{{ this.frames.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Value(Other):
            <span class="orange--text">£{{ this.other.toLocaleString() }}</span>
          </h2>
        </v-flex>
      </v-layout>

      <!-- Middle Column -->
      <v-layout column>
        <v-flex xs4></v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Predicted Workload:
            <span class="green--text"
              >£{{ this.predictedWork.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Projected Sales:
            <span class="green--text"
              >£{{ this.netSales.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
      </v-layout>

      <!-- Right Column -->
      <v-layout column>
        <v-flex xs4>
          <h2 class="primary--text">
            Work in progress:
            <span class="purple--text"
              >£{{ this.workInProgress.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Bought:
            <span class="purple--text"
              >£{{ this.totalBought.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
        <v-flex xs4>
          <h2 class="primary--text">
            Projected Profit:
            <span class="purple--text"
              >£{{ this.projectedProfit.toLocaleString() }}</span
            >
          </h2>
        </v-flex>
      </v-layout>
      <!-- End of Totals -->
    </v-layout>

    <!--Button row -->
    <v-layout row class="py-5">
      <!-- Dialog, add sales -->

      <v-dialog v-model="addSales" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            Add Sales Order
          </v-btn>
        </template>
        <v-form ref="form" lazy-validation="">
          <v-card>
            <v-card-title>
              <span class="headline">Add Item</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="accountItem.worknum"
                      label="Work#"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="accountItem.customer"
                      label="Customer"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="accountItem.product"
                      label="Product"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model.number="accountItem.vdoor"
                      label="Value(Doors)"
                       :rules="[v => !!v || 'This is required if Empty leave 0']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model.number="accountItem.vframe"
                      label="Value(Frames)"
                       :rules="[v => !!v || 'This is required if Empty leave 0']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model.number="accountItem.vother"
                      label="Value(Other)"
                       :rules="[v => !!v || 'This is required if Empty leave 0']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <!-- New Date Picker- -->
                    <v-menu
                      ref="menu2"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="accountItem.date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="accountItem.date"
                          label="Select Date"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[v => !!v || 'This is required']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="accountItem.date"
                        no-title
                        scrollable
                        type="month"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu2.save(accountItem.date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="accountItem.deliverynote"
                      label="Delivery Notes"
                      
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="accountItem.notes"
                      label="Notes"
                       
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="cancel">Cancel</v-btn>
              <v-btn color="blue darken-1" @click="saveSale">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <!-- Dialog, add fixed cost -->
      <v-dialog v-model="addFixed" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            Add Fixed Cost
          </v-btn>
        </template>
        <v-form ref="form2" lazy-validation="">
          <v-card>
            <v-card-title>
              <span class="headline">Add Item</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem2.supplier"
                      label="Supplier"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model.number="editedItem2.value"
                      label="Value"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem2.ordernum"
                      label="Order Num"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="editedItem2.worknum"
                      :items="type"
                      :rules="[v => !!v || 'Product type is required']"
                      prepend-icon="whatshot"
                      label="Frequency"
                      required
                      chips
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4
                    v-if="editedItem2.worknum === 'Quarterly'"
                  >
                    <v-menu>
                      <v-text-field
                        v-model="editedItem2.date"
                        :value="date"
                        slot="activator"
                        label="Delivery Date"
                        prepend-icon="date_range"
                        :rules="[v => !!v || 'This is required']"
                      ></v-text-field>
                      <v-date-picker
                        v-model="editedItem2.date"
                        type="month"
                        multiple
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="editedItem2.worknum === 'Yearly'">
                    <v-menu>
                      <v-text-field
                        v-model="editedItem2.date"
                        :value="date"
                        slot="activator"
                        label="Delivery Date"
                        prepend-icon="date_range"
                        :rules="[v => !!v || 'This is required']"
                      ></v-text-field>
                      <v-date-picker
                        v-model="editedItem2.date"
                        type="month"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem2.deliverynote"
                      label="Deliverynote"
                      
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem2.notes"
                      label="Notes"
                      
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="cancel">Cancel</v-btn>
              <v-btn color="blue darken-1" @click="saveFixed">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <!-- Dialog, add purchase order -->
      <v-dialog v-model="addPurchase" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark v-bind="attrs" v-on="on">
            Add Purchase Order
          </v-btn>
        </template>
        <v-form ref="form3" lazy-validation="">
          <v-card>
            <v-card-title>
              <span class="headline">Add Item</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.ordernum"
                      label="Order#"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.supplier"
                      label="Supplier"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model.number="editedItem.value"
                      label="Value"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.worknum"
                      label="Work#"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-menu
                      ref="menu"
                      v-model="menu3"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.date"
                          label="Select Date"
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[v => !!v || 'This is required']"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.date"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu3 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(editedItem.date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.type"
                      label="type"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.notes"
                      label="Notes"
                       :rules="[v => !!v || 'This is required']"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="cancel">Cancel</v-btn>
              <v-btn color="blue darken-1" @click="savePurchase">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>

    <!--expansion Panels START -->
    <v-layout>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Fixed Cost</v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- Dialog, To month -->
            <v-dialog v-model="sendDown" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  To Month
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">To Month </span>
                  <h4># Selected {{selected.length}}</h4>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-menu
                          ref="menu4"
                          v-model="menu4"
                          :close-on-content-click="false"
                          :return-value.sync="myDate"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="myDate"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="myDate" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu4 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu4.save(myDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="sendDown = false"
                    >Close</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="SendDown"
                    >Send Down</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- Main data table -->
            <v-data-table
              dense
              :headers="headers"
              :items="bought"
              item-key="ordernum"
              :search="search"
              v-model="selected"
              show-select
            >
              <template v-slot:item.checked="{ item }">
                <v-simple-checkbox v-model="item.checked"></v-simple-checkbox>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="fixedEdit(item)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteFixed(item)">delete</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
            <!-- End of CRUD table -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Sales Order</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-btn class="primary">
              <download-excel :data="accounts">Download Data</download-excel>
            </v-btn>
            <v-text-field
              v-model="search2"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- Main data table -->
            <v-data-table
              dense
              :headers="headers2"
              :items="accounts"
              sort-by="name"
              :search="search2"
            >
              <template v-slot:item.checked="{ item }">
                <v-switch v-model="item.checked" :label="`${item.checked}`" @change="check3(item.checked,item)"></v-switch>
              </template>
              <template v-slot:item.progress="{ item }">
                <h3>{{item.progress}}%</h3>
                <v-progress-linear :value="item.progress"></v-progress-linear>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="salesEdit(item)"
                  >edit</v-icon
                >
                <v-icon small @click="deleteSales(item)">delete</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
            <!-- End of CRUD table -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Monthly Cost</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-btn class="primary">
              <download-excel :data="costs">Download Data</download-excel>
            </v-btn>
             <!-- Dialog, To month -->
            <v-dialog v-model="sendDown" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  To Month
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">To Month </span>
                  <h4># Selected {{selected2.length}}</h4>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-menu
                          ref="menu4"
                          v-model="menu4"
                          :close-on-content-click="false"
                          :return-value.sync="myDate"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="myDate"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="myDate" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu4 = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu4.save(myDate)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="sendDown = false"
                    >Close</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="SendDown"
                    >Send Down</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search3"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- Main data table -->
            <v-data-table
              dense
              :headers="headers3"
              :items="costs"
              sort-by="name"
              :search="search3"
              v-model="selected2"
              show-select
            >
            <template v-slot:item.checked="{ item }">
                <v-simple-checkbox v-model="item.checked"></v-simple-checkbox>
              </template>
              <template v-slot:item.checked="{ item }">
                <v-switch v-model="item.checked" :label="`${item.checked}`" @change="check(item.checked,item)"></v-switch>
              </template>
             <!-- <template v-slot:item.checked="{ item }">
                 <v-switch v-model="item.checked" :label="`${item.checked}`" @change="check(item.checked, item)"></v-switch>
                <v-simple-checkbox
                  v-model="item.checked"
                  @change="check(item.checked, item)"
                ></v-simple-checkbox> 
              </template> -->
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="purchaseEdit(item)"
                  >edit</v-icon
                >
                <v-icon small @click="deletePurchase(item)">delete</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
            <!-- End of CRUD table -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Customer Totals</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              v-model="search4"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!-- Main data table -->
            <v-data-table
              dense
              :headers="headers4"
              :items="getCustomers"
              sort-by="name"
              :search="search4"
            >
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                <v-icon small @click="deleteItem(item)">delete</v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>
            <!-- End of CRUD table -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-layout>
    <!--expansion Panels END -->
  </v-container>
</template>

<script>
import moment from "moment";
import db from "@/fb";
export default {
  data: () => ({
    dialog: false,
    show_start_date: false,
    start_date: null,

    show_end_date: false,
    end_date: null,
    filters: {
      search: "",
      added_by: "",
      start_date: null,
      end_date: null
    },
    items: [
      "Doors",
      "Frame",
      "Timber Section",
      "Screens",
      "Glass",
      "Iron Mongory"
    ],
    sdate: moment(new Date()),
    test: "",
    summary: "",
    filterArr: [],
    isActive: true,
    search: "",
    search2: "",
    search3: "",
    search4: "",
    worknum: "",
    customer: "",
    contract: "",
    product: "",
    select: "",
    //fsc:'',
    date: "",
    headers: [
      { text: "Order #", align: "left", value: "ordernum" },
      { text: "Supplier", align: "left", value: "supplier", sortable: false },
      { text: "Value", align: "left", value: "value", sortable: false },
      { text: "Frequency", align: "left", value: "worknum", sortable: false },
      { text: "Dates", align: "left", value: "notes", sortable: false },
      { text: "Actions", align: "left", value: "actions", sortable: false }
      // { text: "Checked", align: "left", value: "checked", sortable: false },
    ],
    headers2: [
      { text: "Work #", align: "left", value: "worknum" },
      { text: "Customer", align: "left", value: "customer", sortable: false },
      { text: "Product", align: "left", value: "product", sortable: false },
      { text: "Value(Door)", align: "left", value: "vdoor", sortable: false },
      { text: "Value(Frame)", align: "left", value: "vframe", sortable: false },
      { text: "Value(Other)", align: "left", value: "vother", sortable: false },
      { text: "Progress", align: "left", value: "progress" },
      { text: "Status", align: "left", value: "status" },
      { text: "Delivery Note#", align: "left", value: "deliverynote" },
      { text: "Total Delivered", align: "left", value: "delivered" },
      { text: "Notes", align: "left", value: "notes" },
      { text: "Invoiced In Full?", align: "left", value: "checked" },
      { text: "Actions", align: "left", value: "actions", sortable: false }
    ],
    headers3: [
      { text: "Order #", align: "left", value: "ordernum" },
      { text: "Supplier", align: "left", value: "supplier" },
      { text: "Value", align: "left", value: "value" },
      { text: "Work #", align: "left", value: "worknum" },
      { text: "Checked", align: "left", value: "checked" },
      { text: "comments", align: "left", value: "notes" },
      { text: "Actions", align: "left", value: "actions", sortable: false }
    ],
    headers4: [
      { text: "Customer", align: "left", value: "customer" },
      { text: "Total(Doors)", align: "left", value: "tdoor" },
      { text: "Total(Frames)", align: "left", value: "tframe" },
      { text: "Total(Other)", align: "left", value: "tother" },
      { text: "Total", align: "left", value: "tTotal" }
    ],
    drawer: false,
    orders: [],
    costs: [],
    doors: 0,
    frames: 0,
    other: 0,
    bought: [],
    predictedWork: 0,
    netSales: 0,
    totalBought: 0,
    projectedProfit: 0,
    workInProgress: 0,
    accounts: [],
    history: [],
    pickerDate: null,
    sendDown: false,
    menu: "",
    menu3: "",
    menu4: "",
    menu16:"",
    myDate: "",
    selected: [],
    selected2:[],
    addSales: false,
    addPurchase: false,
    addFixed: false,
    editSales: false,
    editPurchase: false,
    editFixed: false,
    type: ["Quarterly", "Monthly", "Yearly", "Locked"],
    accountItem: {
      worknum: "",
      customer: "",
      product: "",
      vdoor: 0,
      vframe: 0,
      vother: 0,
      date: "",
      deliverynote: "",
      notes: ""
    },
    editedItem2: {
      supplier: "",
      value: 0,
      worknum: "",
      deliverynote: "",
      notes: "",
      ordernum: "",
      qdate: []
    },
    orders2: [],
    editedIndex: -1,
    timelineItem: {
      worknum: "",
      customer: "",
      contract: "",
      ordernum: "",
      product: "",
      location: "",
      progress: 0,
      fsc: "",
      qty: 0,
      date: "",
      steps: null,
      timeline: null,
      createdBy: ""
    },
    editedItem: {
      worknum: "",
      customer: "",
      location: "",
      quantity: "",
      finish: "",
      inFactory: false,
      mill: false,
      mach: false,
      bench: false,
      spray: false,
      notes: "",
      supplier: "",
      value: 0,
      deliverynote: "",
      notes: "",
      ordernum: "",
      date: "",
      progress:0,
    },
    defaultItem: {
      worknum: "",
      customer: "",
      location: "",
      quantity: "",
      finish: "",
      inFactory: false,
      mill: false,
      mach: false,
      bench: false,
      spray: false,
      notes: ""
    },
    myTestArray: []
  }),
  computed: {
    sortProgress(){


for(var x of this.accounts){
  for(var y of this.orders){
     if(x.worknum.includes(y.worknum)){
       x.progress = y.progress
     }
  }
   for(var z of this.history){
     if(x.worknum.includes(z.worknum)){
        x.progress = z.progress
     }
  }

}


           
    },
    /* getProgress(){

          var newArr =[]
          var arr =[]
          var prog = null
          var stat = null

        

            for(var y=0; y<this.accounts.length; y++){
                   for(var x=0; x<this.orders.length; x++){
                       if(this.accounts[y].worknum == this.orders[x].worknum){
                           this.accounts[y].progress = this.orders[x].progress
                           this.accounts[y].status = this.orders[x].status
                       }
                       if(this.accounts[y].checked ){
                           this.accounts[y].progress = 100
                       }
                    }
                    for(var z=0;z<this.history.length; z++){
                      if(this.accounts[y].worknum == this.history[z].worknum){
                        this.accounts[y].status = this.history[z].status
                        this.accounts[y].progress = this.history[z].progress
                      }
                    }
                    if(this.accounts[y].deliverynote.length >= 2){
                      this.accounts[y].progress = 100
                    }
                }
        }, */
    getCustomers() {
      var result = this.accounts.reduce(
        function(acc, curr) {
          //Map customers together and total up values
          if (curr.customer) {
            var fromMap = acc.map[curr.customer];
            if (!fromMap) {
              acc.map[curr.customer] = fromMap = {
                customer: curr.customer,
                vdoor: curr.vdoor,
                vframe: curr.vframe,
                vother: curr.vother,
                tdoor: 0,
                tframe: 0,
                tother: 0,
                tTotal: 0
              };
              acc.result.push(fromMap);
            }
            //curr.vdoor && Number(curr.vdoor) ? curr.vdoor : 0
            fromMap.tdoor += curr.vdoor && Number(curr.vdoor) ? curr.vdoor : 0;
            fromMap.tframe +=
              curr.vframe && Number(curr.vframe) ? curr.vframe : 0;
            fromMap.tother +=
              curr.vother && Number(curr.vother) ? curr.vother : 0;
            fromMap.tTotal = fromMap.tdoor + fromMap.tframe + fromMap.tother;
          } else {
            acc.result.push(curr);
          }
          return acc;
        },
        {
          map: {},
          result: []
        }
      ).result;
      return result;
    },

    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    pickerDate(val) {
      this.orders = [];
      this.history = [];
      this.workInProgress = 0;
      this.predictedWork = 0;
      this.doors = 0;
      this.frames = 0;
      this.netSales = 0;
      this.predictedWork = 0;
      this.other = 0;
      this.accounts = [];
      this.bought = [];
      this.totalBought = 0;
      this.projectedProfit = 0;

      db.collection("orders")
        .orderBy("worknum", "desc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id
           
              this.orders.push(cache[doc.id]);
           
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
      db.collection("history")
        .orderBy("date", "desc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id
           
              this.history.push(cache[doc.id]);
           

          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
      db.collection("accounts")
        .orderBy("date", "desc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            // doc.data() is never undefined for query doc snapshots
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id
            if (
              moment(cache[doc.id].date).format("MMM YY") ==
              moment(val).format("MMM YY")
            ) {
              cache[doc.id].total = 0;
              if (cache[doc.id].vdoor) {
                this.doors += Number(cache[doc.id].vdoor);
                cache[doc.id].total += Number(cache[doc.id].vdoor);
              }
              if (cache[doc.id].vframe) {
                this.frames += Number(cache[doc.id].vframe);
                cache[doc.id].total += Number(cache[doc.id].vframe);
              }
              if (cache[doc.id].vother) {
                this.other += Number(cache[doc.id].vother);
                cache[doc.id].total += Number(cache[doc.id].vother);
              }
              
          if(!cache[doc.id].progress){
              cache[doc.id].progress = 50
            }



              cache[doc.id].total =
                cache[doc.id].total * Number(cache[doc.id].progress / 100);

              this.workInProgress += Number(cache[doc.id].total);
              this.predictedWork = this.doors + this.frames;
              this.netSales = this.predictedWork + this.other;
              this.accounts.push(cache[doc.id]);
            }
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });

      db.collection("costs")
        .orderBy("date", "desc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id
            if (
              moment(cache[doc.id].date).format("MMM YY") ==
              moment(val).format("MMM YY")
            ) {
              this.costs.push(cache[doc.id]);
              this.totalBought += Number(cache[doc.id].value);
            }
            this.projectedProfit = this.netSales - this.totalBought;
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });

      db.collection("bought")
        .orderBy("ordernum", "asc")
        .get()
        .then(querySnapshot => {
          const cache = [];
          querySnapshot.forEach(doc => {
            cache[doc.id] = doc.data();
            cache[doc.id].id = doc.id
              this.bought.push(cache[doc.id]);
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    }
  },
  mounted() {
    // console.log("App mounted!");
  },

  methods: {
    check(e, item) {
      db.collection("costs")
        .doc(item.id)
        .update({
          checked: e
        })
        .then(() => {
          console.log("Done")
        });
    },
    check3(e,item) {
     
            console.log(item.id)
            
      if (e == false) {
        var stat = " ";
        for (var x = 0; x < this.orders.length; x++) {
          if (this.orders[x].worknum == item.worknum) {
            stat = this.orders[x].status;
          }
        }
        item.status = stat; 
        db.collection("accounts")
          .doc(item.id)
          .update({
            checked: false,
            status: stat
          });
           console.log("CHANGED")
      } else {
        item.status = "Invoiced in Full";
        db.collection("accounts")
          .doc(item.id)
          .update({
            checked: e,
            status: "Invoiced in Full"
          });
           console.log("CHANGED")
      }
    },
    cancel() {
      this.addSales = false;
      this.addPurchase = false;
      this.addFixed = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem2 = Object.assign({}, this.defaultItem);
        this.accountItem = Object.assign({}, this.accountItem);
        this.editedIndex = -1;
      }, 300);
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.editedItem);
        this.editedItem2 = Object.assign({}, this.editedItem2);
        this.accountItem = Object.assign({}, this.accountItem);
        this.editedIndex = -1;
        this.editSales = false;
        this.editPurchase = false;
        this.editFixed = false;
      }, 300);
    },
    fixedEdit(item) {
      this.editedIndex = this.bought.indexOf(item);
      this.editedItem2 = Object.assign({}, item);
      this.editFixed = true;
    },
    purchaseEdit(item) {
      this.editedIndex = this.costs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editPurchase = true;
    },
    salesEdit(item) {
      this.editedIndex = this.accounts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editSales = true;
    },
    deleteFixed(item) {
      const index = this.bought.indexOf(item);
      db.collection("bought")
        .doc(item.id)
        .delete();
      this.bought.splice(index, 1);
      this.$router.replace("accounts");
    },
    deletePurchase(item) {
      const index = this.costs.indexOf(item);
      db.collection("costs")
        .doc(item.id)
        .delete();
      this.costs.splice(index, 1);
      this.$router.replace("accounts");
    },
    deleteSales(item) {
      const index = this.accounts.indexOf(item);
      db.collection("accounts")
        .doc(item.id)
        .delete();
      this.accounts.splice(index, 1);
      this.$router.replace("accounts");
    },

    saveSale() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.accounts[this.editedIndex], this.accountItem);
        } else {
          db.collection("accounts")
            .add(this.accountItem)
            .then(() => {
              //console.log("ADDED to db");
              this.loading = false;
              this.dialog = false;
              this.$emit("orderCreated");
            });
        }
        setTimeout(() => {
          this.accountItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
        this.addSales = false;
        this.close();
      } 
    },
    saveFixed() {
      if (this.$refs.form2.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.bought[this.editedIndex], this.editedItem2);
        } else {
          db.collection("bought")
            .add(this.editedItem2)
            .then(() => {
              // console.log("ADDED to db");
              this.loading = false;
              this.dialog = false;
              this.$emit("orderCreated");
            });
        }
        setTimeout(() => {
          this.editedItem2 = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
        this.addFixed = false;
        this.close();
      }
    },
    savePurchase() {
      if (this.$refs.form3.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.costs[this.editedIndex], this.editedItem);
        } else {
          db.collection("costs")
            .add(this.editedItem)
            .then(() => {
              //console.log("ADDED to db");
              this.loading = false;
              this.dialog = false;
              this.$emit("orderCreated");
            });
        }
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
        this.addPurchase = false;
        this.close();
      }
    },

    SendDown() {
      //var sum = 0;
      for (var i = 0; i < this.selected.length; i++) {
        this.selected[i].date = this.myDate;
        //this.costs.push(this.selected[i])
        //sum = sum + Number(this.selected[i].value)
        db.collection("costs")
          .add(this.selected[i])
          .then(() => {
            //console.log("ADDED to db");
            this.$emit("orderCreated");
          });
      }
      this.selected = [];
      this.sendDown = false;
      //alert(sum)
    },
    updateFixed() {
      if (this.$refs.form4.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.bought[this.editedIndex], this.editedItem2);
        } else {
          this.bought.push(this.editedItem2);
        }

        db.collection("bought")
          .doc(this.bought[this.editedIndex].id)
          .update({
            supplier: this.editedItem2.supplier,
            value: this.editedItem2.value,
            worknum: this.editedItem2.worknum,
            deliverynote: this.editedItem2.deliverynote,
            notes: this.editedItem2.notes,
            ordernum: this.editedItem2.ordernum
          })
          .then(() => {
            this.$emit("Delivered");
            this.editFixed = false;
          });

        this.close();
      }
    },
    updateSales() {
      if (this.$refs.form5.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.accounts[this.editedIndex], this.editedItem);
        } else {
          this.accounts.push(this.editedItem);
        }

        db.collection("accounts")
          .doc(this.accounts[this.editedIndex].id)
          .update({
            worknum: this.editedItem.worknum,
            customer: this.editedItem.customer,
            product: this.editedItem.product,
            vdoor: this.editedItem.vdoor,
            vframe: this.editedItem.vframe,
            vother: this.editedItem.vother,
            date: this.editedItem.date,
            deliverynote: this.editedItem.deliverynote,
            notes: this.editedItem.notes,
            progress: this.editedItem.progress
          })
          .then(() => {
            this.$emit("Delivered");
            this.editSales = false;
          });

        this.close();
        this.$router.replace('accounts')
      }
    },
    updatePurchase() {
      if (this.$refs.form6.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.costs[this.editedIndex], this.editedItem);
        } else {
          this.costs.push(this.editedItem);
        }

        db.collection("costs")
          .doc(this.costs[this.editedIndex].id)
          .update({
            ordernum: this.editedItem.ordernum,
            supplier: this.editedItem.supplier,
            notes: this.editedItem.notes,
            date: this.editedItem.date,
            value: this.editedItem.value,
            worknum: this.editedItem.worknum,
            deliverynote: this.editedItem.deliverynote
          })
          .then(() => {
            this.$emit("Delivered");
            this.editPurchase = false;
          });
        this.close();
      }
    },
    withDateStyle: function(val) {
      //rd is rental duration
      var rd = moment(val.deliverydate).week();
      //console.log(rd)
      var lengthColor;
      var otherCriterionColor;
      if (rd === moment(new Date()).week()) {
        lengthColor = "black";
        otherCriterionColor = "orange";
      } else if (rd > moment(new Date()).week()) {
        lengthColor = "black";
        otherCriterionColor = "orange";
      } else if (rd < moment(new Date()).week()) {
        lengthColor = "black";
        otherCriterionColor = "orange";
      }
      if (val.status === "ON HOLD") {
        lengthColor = "black";
        otherCriterionColor = "red";
      }
      if (val.status === "Delivered") {
        lengthColor = "white";
        otherCriterionColor = "#3C3F40";
      }
      return {
        color: lengthColor,
        background: otherCriterionColor
      };
    },

    deleteItem(item) {
      confirm("Are you sure you want to PERMANENTLY delete this item?");
      db.collection("history")
        .doc(item.id)
        .delete();
      this.$router.replace("history");
    },
    getInfo(item) {
      this.timelineIndex = this.orders.indexOf(item);
      this.timelineItem = Object.assign({}, item);

      this.drawer = true;
    },
    restoreItem(item) {
      db.collection("history")
        .doc(item.id)
        .delete();
      db.collection("orders")
        .add(item)
        .then(() => {
          console.log("ADDED to db");
        });
      db.collection("orders")
        .doc(item.id)
        .update({
          status: "Delivered",
          statusUname: uname,
          statusTime: moment(new Date()).format("YYYY-MM-DD HH:mm")
        })
        .then(() => {
          this.$emit("Delivered");
        });
    }

    /*close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }*/
  }
};
</script>
